import { VectorEditorConstantS } from '../../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { find, go, pluck, sel, some, uniq } from 'fxjs/es';
import { OMPProductListConstantS } from '../../../../OMP/ProductList/S/Constant/module/OMPProductListConstantS.js';
import { makeReviewSummaryData } from '../../../../Maker/S/product.js';
import Ups from '../../../../Ups/S/ups.js';
import { UtilNumberS } from '../../../../Util/Number/S/Function/module/UtilNumberS.js';
import { UtilS } from '../../../../Util/S/Function/module/UtilS.js';
import { calcSizePrice } from '../../../../ProductColorPrice/S/fs.js';
import { BpOptionKeyRingS } from '../../../../BpOption/KeyRing/S/Function/module/BpOptionKeyRingS.js';
import { BpOptionAcrylicFigureS } from '../../../../BpOption/AcrylicFigure/S/Function/module/BpOptionAcrylicFigureS.js';
import { PriceS } from '../../../../Price/S/Function/module/PriceS.js';
import { BpOptionS } from '../../../../BpOption/S/Function/module/BpOptionS.js';

const plusBpName = (product) =>
  [VectorEditorConstantS.STICKER_EDITOR].includes(product._.base_product.maker_type)
    ? ` (${product._.base_product._.base_product_sizes[0]['name' + G._en]})`
    : ``;

const getLocalizedPrice = ({ max, min, is_range = false }) => (is_range ? `${min} ~ ${max}` : max);

const vectorEditorPriceRange = (pc) => {
  const price = go(calcSizePrice(pc, _en), (price) => UtilS.makeCurrencyPrice(PriceS.pricify(price), T.lang));

  const EDITOR_MIN_PRICES = {
    [VectorEditorConstantS.KEYRING_EDITOR]: BpOptionKeyRingS.KEYRING_MIN_PRICE,
    [VectorEditorConstantS.ACRYLIC_FIGURE_EDITOR]: BpOptionAcrylicFigureS.ACRYLIC_FIGURE_MIN_PRICE,
  };

  const min_price_obj = EDITOR_MIN_PRICES?.[pc._?.base_product?.maker_type]?.[pc._?.base_product.id];

  if (min_price_obj) {
    const min_price = UtilS.makeCurrencyPrice(PriceS.pricify(min_price_obj[T.lang]), T.lang);
    if (BpOptionS.isDesigned(pc)) {
      return getLocalizedPrice({ min: min_price, max: price, is_range: false });
    }
    return getLocalizedPrice({ min: min_price, max: price, is_range: min_price !== price });
  } else {
    return `${getLocalizedPrice({ max: price, is_range: false })} ~`;
  }
};

const hasSize = (size_list, size_id) => {
  return go(
    size_list,
    uniq,
    some((bps_id) => bps_id == size_id),
  );
};
export const util = {
  defaultDisabledCartButtton: (pc) => {
    return VectorEditorConstantS.PREVIEW_TYPES.includes(pc._.base_product.maker_type);
  },
  makePriceInfoPerUnit: (pc, { quantity, discounted_price, total_price, discount_percent }) => {
    const is_vector = [
      VectorEditorConstantS.KEYRING_EDITOR,
      VectorEditorConstantS.ACRYLIC_FIGURE_EDITOR,
    ].includes(pc._.base_product.maker_type);
    const vector_price = vectorEditorPriceRange(pc);
    return {
      quantity,
      discounted_price: is_vector
        ? vector_price
        : UtilS.makeCommifiedCurrencyPrice(UtilNumberS.divDecimal(discounted_price, quantity), T.lang),
      original_price: is_vector
        ? undefined
        : UtilS.makeCommifiedCurrencyPrice(UtilNumberS.divDecimal(total_price, quantity), T.lang),
      discount_percent: is_vector ? undefined : discount_percent,
    };
  },
  getSoldOutSizes: (bp, base_product_color_id) => {
    const bpc = go(
      bp._.base_product_colors,
      find((bpc) => bpc.id == base_product_color_id),
    );
    const sold_out_size_ids = go(bpc, sel('_.sold_out_sizes'), pluck('id'));
    return sold_out_size_ids;
  },
  getDiscontinuedSizes: (bp, base_product_color_id) => {
    const bpc = go(
      bp._.base_product_colors,
      find((bpc) => bpc.id == base_product_color_id),
    );
    const sold_out_size_ids = go(bpc, sel('_.discontinued_sizes'), pluck('id'));
    return sold_out_size_ids;
  },
  getPossibleBpsId: (bp, base_product_color_id, base_product_size_id) => {
    try {
      const bpc = go(
        bp._.base_product_colors,
        find((bpc) => bpc.id == base_product_color_id),
      );
      const sold_out_size_ids = go(bpc, sel('_.sold_out_sizes'), pluck('id'));
      const discontinued_size_ids = go(bpc, sel('_.discontinued_sizes'), pluck('id'));
      const possible_size_id = go(
        bp._.base_product_sizes,
        find((bps) => !sold_out_size_ids?.includes(bps.id) & !discontinued_size_ids?.includes(bps.id)),
        sel('id'),
      );
      const possible_bps_id =
        (sold_out_size_ids?.includes(base_product_size_id) ||
          discontinued_size_ids?.includes(base_product_size_id)) &&
        possible_size_id
          ? possible_size_id
          : base_product_size_id;
      return possible_bps_id;
    } catch (e) {}
  },
  isSoldOutSize: ({ base_product_color_id, base_product_size_id }, bp) =>
    hasSize(util.getSoldOutSizes(bp, base_product_color_id), base_product_size_id),

  isDiscontinuedSize: ({ base_product_color_id, base_product_size_id }, bp) => {
    return hasSize(util.getDiscontinuedSizes(bp, base_product_color_id), base_product_size_id);
  },

  isUnavailableSize: ({ base_product_color_id, base_product_size_id }, bp) => {
    return (
      util.isSoldOutSize({ base_product_color_id, base_product_size_id }, bp) ||
      util.isDiscontinuedSize({ base_product_color_id, base_product_size_id }, bp)
    );
  },
  makeBaseProductInfoParams: ({ review_total, pc, up_c_ss }) => {
    const base_product = pc._.base_product;
    const bp_brand = go(
      pc._.base_product._.brand,
      (brand) => brand?.id != OMPProductListConstantS.OTHER_BRAND_ID && brand?.name,
    );

    const bp_name = pc._.base_product['name' + _collabo + _en];
    const { score_float, count } = makeReviewSummaryData({ review_total });

    const up_c_ss_price_info = Ups.calc_up_c_ss_price_info(up_c_ss, G._en);
    const { discounted_price: price, original_price: originalPrice } = util.makePriceInfoPerUnit(
      pc,
      up_c_ss_price_info,
    );
    return {
      // klass: 'section',
      brand: bp_brand,
      productName: bp_name.replace(bp_brand?.name, '').trim() + plusBpName(pc),
      price,
      originalPrice,
      rating: score_float,
      reviewCount: count,
      shippingPrice: UtilS.makeCommifiedCurrencyPrice(T.lang === 'kr' ? 3000 : 0, T.lang),
      liked: !!pc._.base_product._.base_products_like?.user_id,
      user_id: pc._.base_product._.base_products_like?.user_id,
      base_product,
    };
  },
};
